import Skeleton from "@mui/material/Skeleton";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import React from "react";

import Button from "components-redesign/Button/Button";

const FilterList = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

const FilterItem = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 12px",
  gap: "10px",
});

const SelectAllArea = styled("div")({
  padding: "8px 12px",
  borderBottom: "1px solid #eee",
  marginBottom: "4px",
});

const FilterActions = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "8px",
  gap: "8px",
});

const ROW_WIDTHS = ["40%", "35%", "55%", "38%", "28%"];

export const FilterLoading: React.FC = () => (
  <>
    <TextField size="small" placeholder="Search..." disabled fullWidth />

    <SelectAllArea>
      <Skeleton width={80} height={16} />
    </SelectAllArea>

    <FilterList>
      {ROW_WIDTHS.map((width, i) => (
        <FilterItem key={i}>
          <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
            <Skeleton
              variant="circular"
              width={20}
              height={20}
              sx={{ marginRight: "12px", flexShrink: 0 }}
            />
            <Skeleton width={width} height={18} />
          </div>
          <Skeleton variant="circular" width={18} height={18} />
        </FilterItem>
      ))}
    </FilterList>

    <FilterActions>
      <Button variant="text" size="small" disabled>
        Clear
      </Button>
      <Button size="small" disabled>
        Apply
      </Button>
    </FilterActions>
  </>
);
